<template>
    <section id="whyus" class="feature">
      <div class="feature-decor">
        <div class="feature-circle1"><img :src='"../../assets/images/feature2-blue.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="feature-phone">
            <img :src='"../../assets/images/mockups/mainMockupLeft.png"' class="img-fluid" alt="">
          </div>
          <div class="offset-lg-4 col-lg-8">
            <div class="row">
              <div class="col-sm-12 mrgn-md-top">
                <h2 class="title">{{ $t("company.whyus.nav") }} <span> {{ $t("company.whyus.nav1") }}</span></h2>
              </div>
              <div class="col-12 col-md-6">
                <ul class="feature-style">
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{ $t("company.whyus.title1") }}</h3>
                    </div>
                    <div>
                      <p class="height90">{{ $t("company.whyus.text1") }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{ $t("company.whyus.title3") }}</h3>
                    </div>
                    <div>
                      <p>{{ $t("company.whyus.text3") }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{ $t("company.whyus.title5") }}</h3>
                    </div>
                    <div>
                      <p>{{ $t("company.whyus.text5") }}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6 sm-m-top">
                <ul class="feature-style">
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{ $t("company.whyus.title2") }}</h3>
                    </div>
                    <div>
                      <p class="height90">{{ $t("company.whyus.text2") }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{ $t("company.whyus.title4") }}</h3>
                    </div>
                    <div>
                      <p>{{ $t("company.whyus.text4") }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{ $t("company.whyus.title6") }}</h3>
                    </div>
                    <div>
                      <p>{{ $t("company.whyus.text6") }}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="top-margin">
                <a href="#recall" role="button" class="btn btn-custom theme-color theme-color">{{ $t("company.about.button") }}</a>
              </div>
            </div>
          </div>

        </div>
      </div>

    </section>
</template>
<script>
export default {
  name: 'WhyUs'
}
</script>
<style scoped>
  @media only screen and (min-width: 1200px) {
    .height90 {
      height: 90px;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 990px){
    .height90 {
      height: 90px;
    }
  }

  @media only screen and (min-width: 991px) and (max-width: 1199px){
    .height90 {
      height: 120px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/companyPage/company_whyus.vue